import React from 'react';
import MainLayout from 'features/shared/layouts/main';
import KnowledgeMonitoring from 'features/monitoring/';

const MonitoringPage = () => (
  <MainLayout>
    <KnowledgeMonitoring />
  </MainLayout>
);

export default MonitoringPage;
